import { Box, Flex } from "@mantine/core";
import AccountSidebar from "components/AccountSidebar";
import { Outlet, useLocation } from "react-router-dom";

interface MyAccountsPageProps {
  title?: string;
}

const MyAccountsPage = (props: MyAccountsPageProps) => {
  const location = useLocation();

  return (
    <Flex
      mih={600}
      style={{
        width: "100%", // fills parent container
        minWidth: 940, // optional: prevents collapse
        margin: "0 auto", // centers if maxWidth is set
      }}
    >
      <Box w={280} p="md" style={{ flexShrink: 0 }}>
        <AccountSidebar />
      </Box>

      {/* Main Content */}
      <Box
        p="md"
        style={{
          flex: 1, // fills remaining space
          minWidth: 0, // allows shrinking below content width
        }}
      >
        <Outlet />
      </Box>
    </Flex>
  );
};

export default MyAccountsPage;
